<template>
  <v-row>
    <v-col v-if="tradeType === 'buy'" cols="12">
      <div class="py-2 d-flex align-center flex-wrap flex-sm-row flex-column">
        <span class="me-2 font-Regular-12">{{ $t("exchange.canUse") }}</span>
        <span class="me-2 font-Regular-12">{{
          $thousandMask(wallet.base, currentCoin.frontBaseCoinScale)
        }}</span>
        <span class="me-2 font-Regular-12">{{ currentCoin.baseSymbol }}</span>
        <a
          v-if="currentCoin.coinType !== 'VIRTUAL'"
          :href="
            `${baseUrl}/operations/transfer?from=${currentCoin.baseSymbol}`
          "
          class="text-yellow font-Regular-12"
        >
          {{ $t("exchange.balanceIncrease") }}
        </a>
      </div>
      <v-text-field
        disabled
        :placeholder="$t('exchange.buyTip')"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.baseSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">{{ $t("exchange.buyPrice") }}</p>
        </template>
      </v-text-field>
      <v-text-field
        v-model="buy.marketAmount"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="setAmount('buy', 'marketAmount', 'frontBaseCoinScale')"
        @keyup="checkRules('buy', 'marketAmount')"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.baseSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">{{ $t("exchange.buyAmount") }}</p>
        </template>
      </v-text-field>
      <v-slider
        class="ltr"
        color="green"
        v-model="buy.sliderPercent"
        @change="handleBuySlider"
        thumb-label="always"
        track-color="none"
        thumb-color="none"
      >
        <template v-slot:thumb-label="{ value }">
          <span class="font-Regular-12 green--text"
            >{{ value }}%</span
          ></template
        >
      </v-slider>

      <Fee :currentCoin="currentCoin" />
      <v-btn
        block
        color="green"
        :loading="loadBuy"
        @click="buyCrypto"
        :disabled="disableBuy"
        class="white--text mt-8"
        depressed
        large
      >
        {{ $t("exchange.buy") }} ({{ currentCoin.coinSymbol }})
      </v-btn>
    </v-col>
    <v-col v-if="tradeType === 'sell'" cols="12">
      <div class="py-2 d-flex align-center flex-wrap flex-sm-row flex-column">
        <span class="me-2 font-Regular-12">{{ $t("exchange.canUse") }}</span>
        <span class="me-2 font-Regular-12">{{
          $thousandMask(wallet.coin, currentCoin.frontCoinScale)
        }}</span>
        <span class="me-2 font-Regular-12">{{ currentCoin.coinSymbol }}</span>
        <a
          v-if="currentCoin.coinType !== 'VIRTUAL'"
          :href="
            `${baseUrl}/operations/transfer?from=${currentCoin.coinSymbol}`
          "
          class="text-yellow font-Regular-12"
        >
          {{ $t("exchange.balanceIncrease") }}
        </a>
      </div>
      <v-text-field
        disabled
        :placeholder="$t('exchange.sellTip')"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.baseSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">{{ $t("exchange.sellPrice") }}</p>
        </template>
      </v-text-field>
      <v-text-field
        v-model="sell.marketAmount"
        placeholder="0"
        filled
        color="primaryX"
        background-color="var(--v-gray5-base)"
        class="custom-form-control"
        @input="setAmount('sell', 'marketAmount', 'frontCoinScale')"
        @keyup="checkRules('sell', 'marketAmount')"
      >
        <template v-slot:prepend-inner>
          <p class="me-6 mb-0 font-Regular-12" style="width: 50px;">
            {{ currentCoin.coinSymbol }}
          </p>
        </template>
        <template v-slot:append>
          <p class="mb-0 font-Regular-12">{{ $t("exchange.sellAmount") }}</p>
        </template>
      </v-text-field>
      <v-slider
        class="ltr"
        color="red"
        v-model="sell.sliderPercent"
        @change="handleSellSlider"
        thumb-label="always"
        track-color="none"
        thumb-color="none"
      >
        <template v-slot:thumb-label="{ value }">
          <span class="font-Regular-12 red--text">{{ value }}%</span></template
        >
      </v-slider>

      <Fee :currentCoin="currentCoin" />
      <v-btn
        block
        color="red"
        :loading="loadSell"
        @click="sellCrypto"
        :disabled="disableSell"
        class="white--text mt-8"
        depressed
        large
      >
        {{ $t("exchange.sell") }} ({{ currentCoin.coinSymbol }})
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
import $thousandMask from "@/mixins/thousandMask";
import UserCenter from "@/services/modules/market/userCenter";
import { ExchangeService } from "@/services";
import { authMixin } from "@/mixins/authMixin";
import Fee from "@/components/Market/exchange/tradeForms/fee.vue";

export default {
  name: "marketOrder",
  components: { Fee },
  mixins: [$thousandMask, authMixin],
  props: {
    wallet: {
      type: Object,
      required: true
    },
    currentCoin: {
      type: Object,
      required: true
    },
    tradeType: {
      type: String
    }
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      isAdmin: false,
      loadBuy: false,
      loadSell: false,
      buy: {
        marketAmount: "",
        sliderPercent: 0
      },
      sell: {
        marketAmount: "",
        sliderPercent: 0
      }
    };
  },
  computed: {
    disableBuy() {
      if (this.isAdmin) return false;
      else {
        return (
          !this.currentCoin.enableMarketBuy ||
          this.currentCoin.exchangeable === 2 ||
          !this.currentCoin
        );
      }
    },
    disableSell() {
      if (this.isAdmin) return false;
      else {
        return (
          !this.currentCoin.enableMarketSell ||
          this.currentCoin.exchangeable === 2 ||
          !this.currentCoin
        );
      }
    }
  },
  mounted() {
    this.isAuth &&
      UserCenter.checkLogin().then(response => {
        this.isAdmin = response.data.data.isAdmin;
      });
  },
  methods: {
    checkRules(obj, prop) {
      if (this[obj][prop] === "") {
        this.setSliderPercent(obj);
      } else {
        this[obj][prop] = this[obj][prop].replace(/[^\d.,]/g, "");
      }
    },
    setAmount(obj, prop, scale) {
      if (!this[obj][prop]) return;
      const str = this[obj][prop].toString();
      let number = str.replace(/,/gi, "");
      const maskedValue = this.$thousandMask(number, this.currentCoin[scale]);

      // Force update using nextTick
      this.$nextTick(() => {
        this[obj][prop] = maskedValue;
        this.setSliderPercent(obj);
      });
    },
    setSliderPercent(obj) {
      let amount = this[obj].marketAmount.replace(/,/gi, "");
      let account = this.wallet.coin;
      if (obj === "buy") {
        account = this.wallet.base;
      }
      this[obj].sliderPercent =
        account > 0 && parseFloat(amount) > 0
          ? parseFloat(this.mul(this.div(amount, account), 100))
          : 0;
    },
    handleBuySlider(val) {
      let account = this.wallet.base;
      this.buy.marketAmount = this.mul(this.mul(account, val), 0.01);
      this.setAmount("buy", "marketAmount", "frontBaseCoinScale");
    },
    handleSellSlider(val) {
      this.sell.marketAmount = this.mul(this.mul(this.wallet.coin, val), 0.01);
      this.setAmount("sell", "marketAmount", "frontCoinScale");
    },
    buyCrypto() {
      const marketAmount = this.buy.marketAmount.replace(/,/gi, "");
      if (!marketAmount || marketAmount === "0") {
        this.$toast.error(this.$t("exchange.enterBuyPrice"));
        return;
      }
      if (parseFloat(marketAmount) > parseFloat(this.wallet.base)) {
        this.$toast.error(this.$t("exchange.insufficientBalance"));
        return;
      }
      this.loadBuy = true;
      let payload = {
        symbol: this.currentCoin.symbol,
        price: 0,
        amount: marketAmount,
        direction: "BUY",
        type: "MARKET_PRICE",
        useDiscount: "0" //whether to deduct the trial fee 0 not used 1 used
      };
      ExchangeService.addOrder(payload)
        .then(res => {
          if (res.data.code !== 500) {
            this.$toast.success(this.$t("exchange.success"));
          }
          this.$emit("refresh");
          this.buy.sliderPercent = 0;
          this.buy.marketAmount = "";
        })
        .catch(err => {
          this.$toast.success(err.message);
        })
        .finally(() => {
          this.loadBuy = false;
        });
    },
    sellCrypto() {
      const marketAmount = this.sell.marketAmount.replace(/,/gi, "");

      if (!marketAmount || marketAmount === "0") {
        this.$toast.error(this.$t("exchange.enterSellAmount"));
        return;
      }
      if (parseFloat(marketAmount) > parseFloat(this.wallet.coin)) {
        this.$toast.error(this.$t("exchange.insufficientBalance"));
        return;
      }
      this.loadSell = true;
      let payload = {
        symbol: this.currentCoin.symbol,
        price: 0,
        amount: marketAmount,
        direction: "SELL",
        type: "MARKET_PRICE",
        useDiscount: "0" //whether to deduct the trial fee 0 not used 1 used
      };
      ExchangeService.addOrder(payload)
        .then(res => {
          if (res.data.code !== 500) {
            this.$toast.success(this.$t("exchange.success"));
          }
          this.$emit("refresh");
          this.sell.sliderPercent = 0;
          this.sell.marketAmount = "";
        })
        .catch(err => {
          this.$toast.error(err.message);
        })
        .finally(() => {
          this.loadSell = false;
        });
    },
    //// helping methods
    mul(a, b) {
      let c = 0,
        d = a.toString(),
        e = b.toString();
      if (d.split(".")[1]) c += d.split(".")[1].length;
      if (e.split(".")[1]) c += e.split(".")[1].length;
      return (
        (Number(d.replace(".", "")) * Number(e.replace(".", ""))) /
        Math.pow(10, c)
      );
    },
    div(arg1, arg2) {
      let t1 = 0,
        t2 = 0,
        r1,
        r2;
      if (arg1.toString().split(".")[1])
        t1 = arg1.toString().split(".")[1].length;
      if (arg2.toString().split(".")[1])
        t2 = arg2.toString().split(".")[1].length;

      r1 = Number(arg1.toString().replace(".", ""));
      r2 = Number(arg2.toString().replace(".", ""));
      return (r1 / r2) * Math.pow(10, t2 - t1);
    },
    toFloor(number, scale = 8) {
      if (Number(number) === 0) {
        return 0;
      }
      let __str = number + "";
      if (__str.indexOf("e") > -1 || __str.indexOf("E") > -1) {
        let __num = Number(number).toFixed(scale + 1),
          __str = __num + "";
        return __str.substring(0, __str.length - 1);
      } else if (__str.indexOf(".") > -1) {
        if (scale === 0) {
          return __str.substring(0, __str.indexOf("."));
        }
        return __str.substring(0, __str.indexOf(".") + scale + 1);
      } else {
        return __str;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
